import script from "./HistoricalLogsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoricalLogsTable.vue?vue&type=script&setup=true&lang=js"

import "./HistoricalLogsTable.vue?vue&type=style&index=0&id=fb1f6ff0&lang=css"

const __exports__ = script;

export default __exports__